/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NumberCircle04Icon16Light = forwardRef('NumberCircle04Icon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M9.978 9.3V7.468h-.971v1.83H6.159l3.243-5.288H8.295L5.108 9.22v.903h3.899V12h.971v-1.876h1.153V9.3H9.978Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 1.004a7 7 0 1 0 0 14 7 7 0 0 0 0-14Zm-6 7a6 6 0 1 1 12 0 6 6 0 0 1-12 0Z" })));
});
